import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/pages/home'),
    },
    {
        path: '/detail',
        name: 'Detail',
        component: () => import('@/pages/detail'),
    },
    {
        path: '/rules',
        name: 'Rules',
        component: () => import('@/pages/rules/index'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js